import i18next from "i18next";
import styles from "../styles.css";

export const getNewTemplate = () => `
    <style>
        ${styles}
    </style>
    <div class="modal-week-container">
        <div class="input-container" slot="children">

            <div class="form-row">
                <div class="form-block">
                    <p class="form-label">${i18next.t($ => $.scheduleBacnet.daysOfWeek)}</p>
                    <div class="form-row week-days-container">
                        <fw-checkbox>${i18next.t($ => $.scheduleBacnet.mo)}</fw-checkbox>
                        <fw-checkbox>${i18next.t($ => $.scheduleBacnet.tu)}</fw-checkbox>
                        <fw-checkbox>${i18next.t($ => $.scheduleBacnet.we)}</fw-checkbox> 
                        <fw-checkbox>${i18next.t($ => $.scheduleBacnet.th)}</fw-checkbox>
                        <fw-checkbox>${i18next.t($ => $.scheduleBacnet.fr)}</fw-checkbox>
                        <fw-checkbox>${i18next.t($ => $.scheduleBacnet.sa)}</fw-checkbox>
                        <fw-checkbox>${i18next.t($ => $.scheduleBacnet.su)}</fw-checkbox>
                    </div>
                </div>          
            </div>

            <div class="form-row form-title justify-between">
                <p>${i18next.t($ => $.scheduleBacnet.event)}</p>
                <fw-button id="add-event" color="secondary">${i18next.t($ => $.scheduleBacnet.add)}</fw-button>
            </div>

            <div class="grid-container">
                <div class="grid-header">
                    <div>${i18next.t($ => $.scheduleBacnet.time)}</div>
                    <div>${i18next.t($ => $.scheduleBacnet.dataType)}</div>
                    <div>${i18next.t($ => $.scheduleBacnet.value)}</div>
                    <div></div> <!-- Пустой элемент для крестика удаления -->
                </div>
                <div class="grid-body" id="events">
                    
                </div>
            </div>  
        </div>
        
        <div class="modal-buttons-wrap">
            <fw-tooltip id="tooltip" placement="bottom" trigger="hover" content="">
                <fw-button id="submit" color="primary">${i18next.t($ => $.apply)}</fw-button>
            </fw-tooltip>
            <fw-button id="reset" color="secondary">${i18next.t($ => $.cancel)}</fw-button>
        </div>
    </div>
`;
